
import { Component, Vue, Prop } from 'vue-property-decorator'
import { SchoolNoticeVO, SchoolNoticeSlvVO } from './vo/CalendarVO'
import Calendar from '@/components/Calendar.vue'
import axios from 'axios';
import CommonUtils from '@/common-utils';

@Component
export default class Notification extends Vue {

}
